import React, { useState } from "react"
import { Alert, Button, Input, Space, Spin, Switch, Tag, message } from "antd"
import { useQuery } from "@tanstack/react-query"
import { request } from "../../../../utils/config"

// ============================================================================
// Tog'a #342 (katalog #6024): «🔐 Двухэтапная проверка (Telegram)» — profilda yoqish / o'chirish.
// Kirishda parol to'g'ri bo'lsa ulangan Telegram'ga 6 xonali kod keladi (backend: AuthLogic «2FA_REQUIRED» → AccountAPI/VerifyTwoFactor).
// Yoqish — faqat shu Telegram'ga yuborilgan sinov kodi kiritilsa (Helpers/TwoFactorEnableStart → TwoFactorSetup): Telegram ishlamasa
// foydalanuvchi o'zini qulflab qo'ymaydi. Telegram «📊 Ежедневный отчёт» blokidagi «Подключить Telegram» orqali ulanadi.
// ============================================================================
export default function TwoFactorSettings() {
  const { data, isFetching, refetch } = useQuery(["TWO_FACTOR_STATUS"], async () => (await request({ url: "Helpers/TwoFactorStatus" })).data, { refetchInterval: 15000 })
  const [kodYuborildi, setKodYuborildi] = useState(false)
  const [kod, setKod] = useState("")
  const [busy, setBusy] = useState(false)
  if (!data) return <Spin spinning={isFetching} />
  const xato = (e: any) => message.error(e?.response?.data?.message || "Ошибка")

  const yubor = async () => {
    setBusy(true)
    try { await request({ url: "Helpers/TwoFactorEnableStart", method: "POST" }); setKodYuborildi(true); setKod(""); message.success("Код отправлен в Telegram") }
    catch (e) { xato(e) } finally { setBusy(false) }
  }
  const yoq = async () => {
    setBusy(true)
    try { await request({ url: "Helpers/TwoFactorSetup", method: "POST", data: { enable: true, code: kod.trim() } }); setKodYuborildi(false); message.success("Двухэтапная проверка включена"); refetch() }
    catch (e) { xato(e) } finally { setBusy(false) }
  }
  const ochir = async () => {
    setBusy(true)
    try { await request({ url: "Helpers/TwoFactorSetup", method: "POST", data: { enable: false } }); message.success("Двухэтапная проверка выключена"); refetch() }
    catch (e) { xato(e) } finally { setBusy(false) }
  }

  return (
    <div data-testid="twofa-settings">
      <div style={{ color: "#64748b", fontSize: 12, marginBottom: 8 }}>
        При входе после пароля в ваш Telegram придёт 6-значный код — без него войти нельзя, даже зная пароль.
      </div>
      {!data.hasTelegramChatId ? (
        <Alert type="info" showIcon message="Сначала подключите Telegram — кнопка «Подключить Telegram» в блоке «Ежедневный отчёт» ниже." />
      ) : data.twoFactorEnabled ? (
        <Space wrap>
          <Tag color="green" style={{ margin: 0 }}>🔐 Включена</Tag>
          <Switch checked loading={busy} onChange={(v) => { if (!v) ochir() }} data-testid="twofa-switch" />
          <span style={{ fontSize: 12, color: "#64748b" }}>выключить</span>
        </Space>
      ) : !kodYuborildi ? (
        <Space wrap>
          <Tag style={{ margin: 0 }}>Выключена</Tag>
          <Button type="primary" loading={busy} onClick={yubor} data-testid="twofa-start">🔐 Включить</Button>
        </Space>
      ) : (
        <Space wrap>
          <Input value={kod} onChange={(e) => setKod(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="Код из Telegram" style={{ width: 160 }} inputMode="numeric" data-testid="twofa-code" />
          <Button type="primary" loading={busy} disabled={kod.length !== 6} onClick={yoq} data-testid="twofa-confirm">Подтвердить</Button>
          <Button type="link" onClick={yubor} disabled={busy}>Отправить код ещё раз</Button>
          <Button type="link" onClick={() => setKodYuborildi(false)}>Отмена</Button>
        </Space>
      )}
    </div>
  )
}
